
import React, { useState } from 'react';
import { useYear } from './YearContext';
import { useLocation, Link } from 'react-router-dom';
import { MenuHamburguer, UserMaleCircle } from './icons/icons.js';
import { useEffect } from 'react';
import supabase from './config/supabaseClient.js';

function NavBar() {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const location = useLocation();
  const [years, setYears] = useState([]);
  const { year: selectedYear, setYear: setSelectedYear } = useYear();

  const toggleNav = () => {
    setIsNavOpen(prev => !prev);
  };

  // Hide menu on the '/' route
  const isMenuVisible = location.pathname !== '/';

  useEffect(() => {
    const fetchYears = async () => {
      const { data, error } = await supabase
        .from("year")
        .select("year")
        .order("year", { ascending: true });

      if (error) {
        console.error("Error fetching years:", error);
      } else {
        setYears(data);
        // Only set the default year if not already set
        if (data.length > 0 && (!selectedYear || selectedYear === '')) {
          setSelectedYear(data[0].year);
        }
      }
    };
    fetchYears();
    // Only run this effect on mount and when selectedYear changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedYear, setSelectedYear]);

  const styles = {
    topBar: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      width: '100%',
      backgroundColor: '#333', // Adjust background color as needed
      color: 'white',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '10px',
      zIndex: 1000, // Ensure the top bar is above other content
    },
    mainContent: {
      paddingTop: '60px', // Adjust this value to match the height of the top bar
    },
    navToggle: {
      background: 'none',
      border: 'none',
      color: 'white',
      fontSize: '16px',
      cursor: 'pointer',
    },
    loginBtn: {
      background: 'none',
      border: 'none',
      color: 'white',
      fontSize: '16px',
      marginRight: '20px',
      alignSelf: 'flex-end',
      cursor: 'pointer',
    },
    navMenu: {
      position: 'fixed',
      top: '60px', // Adjust based on the height of the top bar
      right: 0,
      width: '250px', // Adjust width as needed
      height: 'calc(100% - 60px)', // Adjust based on the height of the top bar
      backgroundColor: '#444', // Adjust background color as needed
      color: 'white',
      display: 'flex',
      flexDirection: 'column',
      paddingTop: '10px',
      boxShadow: '-2px 0 5px rgba(0, 0, 0, 0.5)',
      transform: 'translateX(100%)',
      transition: 'transform 0.3s ease',
      zIndex: 1000, // Ensure the nav menu is above other content
      overflowY: 'auto', // Make the menu scrollable
    },
    navMenuShow: {
      transform: 'translateX(0)',
    },
    navClose: {
      background: 'none',
      border: 'none',
      color: 'white',
      fontSize: '24px',
      cursor: 'pointer',
      alignSelf: 'flex-end',
      padding: '10px',
    },
    navMenuList: {
      listStyle: 'none',
      padding: 0,
      margin: 0,
    },
    navMenuItem: {
      margin: '20px 0',
    },
    navMenuLink: {
      color: 'white',
      textDecoration: 'none',
      fontSize: '18px',
    },
  };

  return (
    <>
      {isMenuVisible && (
        <div style={styles.topBar}>
          <button style={styles.navToggle} onClick={toggleNav}>
            {/* {isNavOpen ? 'Close' : 'Menu'} */}
            <MenuHamburguer/>
          </button>
          <Link to="/profile">
  <button style={styles.loginBtn}>
    <UserMaleCircle />
  </button>
</Link>

        </div>
      )}
      {isMenuVisible && (
        <nav style={{ ...styles.navMenu, ...(isNavOpen ? styles.navMenuShow : {}) }}>
          <button style={styles.navClose} onClick={toggleNav}>✕</button>
          <ul style={styles.navMenuList}>
            <li style={styles.navMenuItem}><a href="/home" style={styles.navMenuLink}>Home</a></li>
            <li style={styles.navMenuItem}><a href="/players" style={styles.navMenuLink}>Players</a></li>
            <li style={styles.navMenuItem}><a href="/medical" style={styles.navMenuLink}>Medical</a></li>
            <li style={styles.navMenuItem}><a href="/practices" style={styles.navMenuLink}>Practices</a></li>
            <li style={styles.navMenuItem}><a href="/talk" style={styles.navMenuLink}>Talk Archive</a></li>
            <li style={styles.navMenuItem}><a href="/scouting" style={styles.navMenuLink}>Scouting</a></li>
            <li style={styles.navMenuItem}><a href="/tests" style={styles.navMenuLink}>Tests</a></li>
            <li style={styles.navMenuItem}><a href="/games" style={styles.navMenuLink}>Games</a></li>
            <li style={styles.navMenuItem}><a href="/create_adversarie" style={styles.navMenuLink}>Create Adversarie</a></li>
            <li style={styles.navMenuItem}><a href="/exercises" style={styles.navMenuLink}>Exercises</a></li>
            <li style={styles.navMenuItem}><a href="/admin" style={styles.navMenuLink}>Admin</a></li>
            <li style={styles.navMenuItem}><a href="/" style={styles.navMenuLink}>Log-out</a></li>
            <li style={styles.navMenuItem}><a href="/image-converter" style={styles.navMenuLink}>Image Converter</a></li>
            <li style={styles.navMenuItem}><a href="/tactical-board" style={styles.navMenuLink}>Tactical Board</a></li>
            <li style={styles.navMenuItem}><a href="/UploadImages" style={styles.navMenuLink}>Upload Images</a></li>
            <li style={styles.navMenuItem}><a href="/display-images" style={styles.navMenuLink}>Display Images</a></li>
            <li style={styles.navMenuItem}><a href="/add-user-to-group" style={styles.navMenuLink}>Add User to Group</a></li>
            <li style={styles.navMenuItem}><a href="/gpx-uploader" style={styles.navMenuLink}>GPX Uploader</a></li>
            <li style={styles.navMenuItem}><a href="/youtube" style={styles.navMenuLink}>YouTube</a></li>
            <li style={styles.navMenuItem}><a href="/sign-up-with-email" style={styles.navMenuLink}>Sign Up with Email</a></li>
          
           {/* Year Selector at bottom */}
        <div style={{ marginTop: "40px", padding: "20px", textAlign: "center" }}>
          <label htmlFor="yearSelect" style={{ marginRight: "10px", fontSize: "18px" }}>
            Select Year:
          </label>
<select
  id="yearSelect"
  value={selectedYear || ''}
  onChange={(e) => setSelectedYear(e.target.value)} // keep as string
  style={{ fontSize: "16px", padding: "5px" }}
>
  {years.map((y, index) => (
    <option key={index} value={y.year}>
      {y.year}
    </option>
  ))}
</select>


        </div>
          
          </ul>
        </nav>
      )}
      <div style={styles.mainContent}>
        {/* Your page content goes here */}
      </div>
    </>
  );
}

export default NavBar;
